import * as React from "react";
import { cn } from "@/lib/utils";
import { Card, CardContent } from "@/components/ui/card";

export interface StatProps {
  title: string;
  value: React.ReactNode;
  description?: string;
  icon?: React.ReactNode;
  className?: string;
}

export function Stat({ title, value, description, icon, className }: StatProps) {
  return (
    <Card size="sm" className={cn(className)}>
      <CardContent className="py-4">
        <div className="flex items-center justify-between">
          <div className="text-xs uppercase opacity-60">{title}</div>
          {icon}
        </div>
        <div className="text-3xl font-semibold">{value}</div>
        {description && <div className="text-xs opacity-60">{description}</div>}
      </CardContent>
    </Card>
  );
}
